import { removeFromObject } from '../utils/immutable';

// Constants:
const SET_ATTEMPTS = 'SET_ATTEMPTS';
const INCREMENT_ATTEMPTS = 'INCREMENT_ATTEMPTS';
const SET_SCORE = 'SET_SCORE';
const ADD_SCORE = 'ADD_SCORE';
const SET_POSSIBLE_SCORE = 'SET_POSSIBLE_SCORE';
const STORE_COMPLETION = 'STORE_COMPLETION';
const STORE_INPUT = 'STORE_INPUT';
const STORE_VALIDATION_RESULT = 'STORE_VALIDATION_RESULT';
const RESET_VALIDATION = 'RESET_VALIDATION';
const ADD_TO_REVIEW = 'ADD_TO_REVIEW';

// Action Creators:
export const storeInput = (id, input) => ({
  type: STORE_INPUT,
  id,
  input
});

export const storeValidationResult = (id, result) => ({
  type: STORE_VALIDATION_RESULT,
  id,
  result
});

export const resetValidation = id => ({
  type: RESET_VALIDATION,
  id
});

export const storeCompletion = id => ({
  type: STORE_COMPLETION,
  id
});

export const setAttempts = (id, attempts) => {
  return {
    type: SET_ATTEMPTS,
    id,
    attempts
  };
};

export const incrementAttempts = id => {
  return {
    type: INCREMENT_ATTEMPTS,
    id
  };
};

export const setScore = (id, score) => {
  return {
    type: SET_SCORE,
    id,
    score
  };
};

export const addScore = (id, score) => {
  return {
    type: ADD_SCORE,
    id,
    score
  };
};

export const setPossibleScore = (id, score) => {
  return {
    type: SET_POSSIBLE_SCORE,
    id,
    score
  };
};

export const addQuestionToReview = (id, question) => {
  return {
    type: ADD_TO_REVIEW,
    id,
    question
  };
};

const initialState = {
  input: {},
  validated: {},
  completed: [],
  attempts: {},
  scores: {},
  possibleScores: {},
  review: []
};

export default function taskReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_INPUT: {
      const input = { ...state.input };
      input[action.id] = action.input;

      return {
        ...state,
        input
      };
    }
    case STORE_VALIDATION_RESULT: {
      const validated = { ...state.validated };
      validated[action.id] = action.result;

      return {
        ...state,
        validated
      };
    }
    case RESET_VALIDATION: {
      return {
        ...state,
        input: removeFromObject(state.input, action.id), // should input reset be mixed in with RESET_VALIDATION?
        validated: removeFromObject(state.validated, action.id)
      };
    }
    case STORE_COMPLETION: {
      const completed = [...state.completed];
      completed.push(action.id);

      return {
        ...state,
        completed
      };
    }
    case SET_ATTEMPTS:
      const attempts = { ...state.attempts };
      attempts[action.id] = action.attempts;

      return {
        ...state,
        attempts
      };
    case INCREMENT_ATTEMPTS:
      const inc_attempts = { ...state.attempts };
      inc_attempts[action.id] = inc_attempts[action.id] + 1;
      return {
        ...state,
        attempts: inc_attempts
      };
    case SET_SCORE:
      // Warning: wipes out any existing score!
      let replaced_scores = { ...state.scores };
      replaced_scores[action.id] = action.score;

      return {
        ...state,
        scores: replaced_scores
      };
    case ADD_SCORE:
      let new_scores = { ...state.scores };
      if (!new_scores[action.id]) {
        new_scores[action.id] = action.score;
      } else {
        new_scores[action.id] += action.score;
      }

      return {
        ...state,
        scores: new_scores
      };
    case SET_POSSIBLE_SCORE:
      let newPossibleScores = { ...state.possibleScores };
      newPossibleScores[action.id] = action.score;

      return {
        ...state,
        possibleScores: newPossibleScores
      };
    case ADD_TO_REVIEW:
      return {
        ...state,
        review: [...state.review, action.question]
      };
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ../core/src/store/task.js